import api from "./api.service";
import { AxiosResponse } from "axios";

class ShortlistService {
  public static readonly generateShortlistLink = (opportunityId: string): Promise<AxiosResponse<any>> => {
    return api.get(`shortlist/${opportunityId}`);
  };

  public static readonly renewShortlistLink = (token: string): Promise<AxiosResponse<any>> => {
    return api.put(`shortlist/renew/${token}`);
  }

  public static readonly blockShortlistLink = (tokenId: string, isBlocked: { blocked: boolean }): Promise<AxiosResponse<any>> => {
    return api.post(`shortlist/block/${tokenId}`, isBlocked);
  }

  public static readonly regenerateShortlistLink = (opportunityId: string): Promise<AxiosResponse<any>> => {
    return api.put(`shortlist/regenerate/${opportunityId}`);
  }

  public static readonly getShortlistLinkByOpportunity = (opportunityId: string): Promise<AxiosResponse<any>> => {
    return api.get(`shortlist/opportunity/${opportunityId}`);
  }

  public static readonly getShortlistToken = (token: string): Promise<AxiosResponse<any>> => {
    return api.get(`shortlist-kanban/${token}`);
  }

  public static readonly updateShortlistkanban = (tokenAccess: string, candidate: Array<any>): Promise<AxiosResponse<any>> => {
    return api.put(`shortlist-kanban/${tokenAccess}`, candidate);
  }
}
export default ShortlistService;